import symbolsData from "./symbols_mini.json";

const availableChars = new Set(symbolsData.map(d => d.Char));

const lookalikes = {
  'a': ['à','á','â','ã','ä','å','ā','ă','ą','ɑ','ɐ'],
  'A': ['À','Á','Â','Ã','Ä','Å','Ā','Ă','Ą'],
  'b': ['ƀ','ɓ','ƃ'],
  'B': ['Ɓ','Ƃ'],
  'c': ['ç','ć','ĉ','ċ','č','ɔ','ɕ'],
  'C': ['Ç','Ć','Ĉ','Ċ','Č'],
  'd': ['ď','đ','ð','ɖ','ɗ'],
  'D': ['Ď','Đ','Ð'],
  'e': ['è','é','ê','ë','ē','ĕ','ė','ę','ě','ɛ','ə'],
  'E': ['È','É','Ê','Ë','Ē','Ĕ','Ė','Ę','Ě'],
  'f': ['ƒ'],
  'g': ['ĝ','ğ','ġ','ģ'],
  'G': ['Ĝ','Ğ','Ġ','Ģ'],
  'h': ['ĥ','ħ','ɦ','ɧ'],
  'H': ['Ĥ','Ħ'],
  'i': ['ì','í','î','ï','ĩ','ī','ĭ','į','ı','ɨ','ɩ'],
  'I': ['Ì','Í','Î','Ï','Ĩ','Ī','Ĭ','Į','İ'],
  'j': ['ĵ','ɟ'],
  'J': ['Ĵ'],
  'k': ['ķ','ĸ'],
  'K': ['Ķ'],
  'l': ['ĺ','ļ','ľ','ŀ','ł','ɫ','ɬ','ɭ'],
  'L': ['Ĺ','Ļ','Ľ','Ŀ','Ł'],
  'm': ['ɱ','ɯ','ɰ'],
  'M': ['Ɯ'],
  'n': ['ñ','ń','ņ','ň','ŉ','ŋ','ɲ','ɳ','ɴ'],
  'N': ['Ñ','Ń','Ņ','Ň','Ŋ'],
  'o': ['ò','ó','ô','õ','ö','ø','ō','ŏ','ő','ɵ','ɶ'],
  'O': ['Ò','Ó','Ô','Õ','Ö','Ø','Ō','Ŏ','Ő'],
  'p': ['ƥ'],
  'r': ['ŕ','ŗ','ř','ɾ','ɻ','ɼ','ɽ'],
  'R': ['Ŕ','Ŗ','Ř'],
  's': ['ś','ŝ','ş','š','ß','ƨ'],
  'S': ['Ś','Ŝ','Ş','Š','Ƨ'],
  't': ['ţ','ť','ŧ','ƫ','ƭ'],
  'T': ['Ţ','Ť','Ŧ'],
  'u': ['ù','ú','û','ü','ũ','ū','ŭ','ů','ű','ų','ʊ','ɥ'],
  'U': ['Ù','Ú','Û','Ü','Ũ','Ū','Ŭ','Ů','Ű','Ų'],
  'v': ['ʋ','ʌ'],
  'V': ['Ʋ'],
  'w': ['ŵ','ʍ'],
  'W': ['Ŵ'],
  'y': ['ý','ÿ','ŷ','ʏ'],
  'Y': ['Ý','Ÿ','Ŷ','Ƴ'],
  'z': ['ź','ż','ž','ʒ','ƶ'],
  'Z': ['Ź','Ż','Ž','Ƶ'],
};

export function pickLookalike(char) {
  const candidates = (lookalikes[char] || []).filter(c => availableChars.has(c));
  if (!candidates.length) return char;
  return candidates[Math.floor(Math.random() * candidates.length)];
}

// Returns [originalChar, lookalike1, lookalike2, ...] for cycling
export function getCycle(char) {
  const candidates = (lookalikes[char] || []).filter(c => availableChars.has(c));
  return [char, ...candidates];
}
